import lscache from 'lscache';
import OAuthButton from 'modules/authentication/components/AuthButtons/OAuthButton';
import { signIn } from 'modules/authentication/helpers/nextauth';
import React, { useState } from 'react';

type AppleLoginProps = {
  isLogin?: boolean;
  afterLogin?: () => boolean;
  onLoginResult: (
    state: any,
  ) => ({
    error,
    success,
    redirectUrl,
  }: {
    error?: any;
    success: boolean;
    redirectUrl?: string;
  }) => void;
  callbackUrl?: string;
  isLastUsed?: boolean;
};

const INITIAL_STATE = {
  loading: false,
  error: null,
};

function AppleLogin({
  isLogin,
  afterLogin,
  callbackUrl,
  onLoginResult,
  isLastUsed,
}: AppleLoginProps) {
  const [state, setState] = useState(INITIAL_STATE);

  const onLoginClick = async () => {
    setState({ error: null, loading: true });
    try {
      await signIn('apple', callbackUrl, onLoginResult(setState));
      lscache.set('lastUsedProvider', 'apple');
      setState({ error: null, loading: false });
      const hideLoading = afterLogin?.();
      if (hideLoading) {
        setState({ error: null, loading: false });
      }
    } catch (exception) {
      setState({ error: exception, loading: false });
    }
  };

  return (
    <OAuthButton
      onClick={onLoginClick}
      provider="apple"
      isLogin={isLogin}
      isLoading={state.loading}
      hasError={!!state.error}
      isLastUsed={isLastUsed}
    />
  );
}

export default AppleLogin;
